<template>
<!--  <div class="cog-topbar">
    <div class="cog-topbar__main">
      <el-button class="menu-toggle" :icon="expanded ? 'el-icon-s-fold' : 'el-icon-s-unfold'" @click="toggle(expanded)"></el-button>
      <div class="cog-topbar__title">
        <h1>{{ routeTitle }}</h1>
        <p>{{ routeSubtitle }}</p>
      </div>
    </div>

    <div class="cog-topbar__actions">
      <div class="topbar-chip">
        <span class="chip-dot"></span>
        <span>COG主播平台后台管理系统</span>
      </div>
      <div class="topbar-user">
        <div class="topbar-user__avatar">{{ userInitial }}</div>
        <div class="topbar-user__meta">
          <div class="topbar-user__name">{{ userName }}</div>
          <div class="topbar-user__role">{{ userRole }}</div>
        </div>
      </div>
      <el-button type="danger" plain size="small" @click="exit">退出登录</el-button>
    </div>
  </div> -->
</template>

<script>
import { adminu, loginout } from '../api/userMG'

export default {
  name: 'navcon',
  data() {
    return {
      expanded: true,
      user: {}
    }
  },
  computed: {
    routeTitle() {
      return this.$route.name || '平台概览'
    },
    routeSubtitle() {
      return '聚焦主播资产、内容接入、平台治理与运营分析。'
    },
    userName() {
      if (this.user.is_superuser) {
        return '系统管理员'
      }
      return this.user.username || '平台用户'
    },
    userRole() {
      return this.user.is_superuser ? '超级管理员' : '运营账号'
    },
    userInitial() {
      return this.userName.slice(0, 1)
    }
  },
  created() {
    this.getUser()
  },
  methods: {
    getUser() {
      adminu()
        .then(res => {
          const userData = res && res.data ? res.data : res

          if (userData && typeof userData === 'object' && !userData.message && !userData.detail) {
            this.user = userData || {}
            localStorage.setItem('userInfo', JSON.stringify(this.user || {}))
            return
          }

          if (res && (res.message || res.detail)) {
            this.$message.error(res.message || res.detail)
            setTimeout(() => {
              this.$store.commit('logout', 'false')
              this.$router.push({ path: '/login' })
            }, 1000)
            return
          }

          this.$message.error('登录已失效')
        })
        .catch(() => {
          this.$message.error('登录已失效')
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
          }, 300)
        })
    },
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const finishLogout = () => {
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }

          loginout()
            .then(finishLogout)
            .catch(finishLogout)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    toggle(showtype) {
      this.expanded = !showtype
      this.$root.Bus.$emit('toggle', this.expanded)
    }
  }
}
</script>

<style scoped>
.cog-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border: 1px solid var(--cog-border-light);
  border-radius: var(--cog-radius-lg);
  background: rgba(255, 255, 255, 0.9);
  box-shadow: var(--cog-shadow-sm);
}

.cog-topbar__main,
.cog-topbar__actions,
.topbar-user {
  display: flex;
  align-items: center;
}

.cog-topbar__main {
  gap: 14px;
  min-width: 0;
}

.cog-topbar__actions {
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.menu-toggle {
  width: 40px;
  height: 40px;
  padding: 0;
}

.cog-topbar__title h1 {
  margin: 0;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 700;
  color: var(--cog-text);
}

.cog-topbar__title p {
  margin: 6px 0 0;
  font-size: 13px;
  color: var(--cog-text-secondary);
}

.topbar-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  background: #eef2ff;
  color: var(--cog-primary-dark);
  font-size: 12px;
  font-weight: 600;
}

.chip-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--cog-primary), var(--cog-accent));
}

.topbar-user {
  gap: 10px;
  padding: 4px 6px;
}

.topbar-user__avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--cog-primary), var(--cog-accent));
  color: #fff;
  font-size: 14px;
  font-weight: 700;
}

.topbar-user__name {
  font-size: 13px;
  font-weight: 600;
  color: var(--cog-text);
}

.topbar-user__role {
  margin-top: 2px;
  font-size: 12px;
  color: var(--cog-text-secondary);
}

@media (max-width: 992px) {
  .cog-topbar {
    flex-direction: column;
    align-items: stretch;
  }

  .cog-topbar__actions {
    justify-content: flex-start;
  }
}

@media (max-width: 768px) {
  .cog-topbar {
    padding: 16px;
  }

  .cog-topbar__title h1 {
    font-size: 20px;
  }

  .topbar-chip {
    width: 100%;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue